import { useEffect, useState, useMemo, useRef } from 'react';
import close from '../../../assets/icons/close.svg';
import next from '../../../assets/icons/icon.svg';
import useAutoFocus from '../../../Utils/autoFocus';
import '../../../assets/css/StudentDashboard.css'
import Select from 'react-select';
import { reactSelectStyles } from '../../../Utils/selectBoxStyle';
import { getData, Postdata, Postdataform } from '../../../API/GlobalApi';
import '../../../assets/css/Modal.css';
import { useNavigate, useParams } from 'react-router-dom';
import ConfirmationModal from '../../../Component/Modals/ConfirmationModal';
import PrintNoticeModal from '../../../Component/Modals/PrintNoticeModal';
import Lottie from "lottie-react";
import nocourseImg from '../../../assets/Images/no-course-removebg-preview.png'
import FeePlanModal from '../../../Component/Modals/FeePlanShowModal';
import FeeNoticeCourseWise from '../../../Component/Modals/FeeNoticeCourseWisePrint';
import Notifier from '../../../Utils/notify';
import '../../../assets/css/Modal.css'
import AddFeeHeadModal from '../../../Component/Modals/AddFeeHead';
import FeeNoticeCourseWiseFromNotice from '../../../Component/Modals/FeeNoticeStudentWisePrint';
import FeeNoticeStudentWise from '../../../Component/Modals/FeeNoticeStudentWisePrint';
import { ScheduleFeePreview } from '../../../Component/Modals/ScheduledFeeDuePreview';
import OtpModal from '../../../Component/Modals/DiscountOtpInput';
import { generateScheduledFeePDF } from '../../../Utils/generatePdfForTemplateSent';
import { v4 as uuidv4 } from "uuid";

import { WaitFeeApprovalsModal } from '../../../Component/Modals/WaitApprovalForFeeTemplate';
export const AddScheduledFee = () => {



    const { id } = useParams();
    const [planMode, setPlanMode] = useState("course");
    const [showDueOnly, setShowDueOnly] = useState(false);
    const [selectedRows, setSelectedRows] = useState({});
    const [balanceToggle, setBalanceToggle] = useState({});
    const [courseData, setCourseData] = useState([]);
    const [courseOptions, setCourseOptions] = useState([]);
    const [semesterOptions, setSemesterOptions] = useState([]);
    const [sectionOptions, setSectionOptions] = useState([]);
    const [selectedCourse, setSelectedCourse] = useState([]);
    const [selectedSemester, setSelectedSemester] = useState([]);
    const [selectedSections, setSelectedSections] = useState([]);
    const [allCourseStudents, setAllCourseStudents] = useState([]);
    const [students, setStudents] = useState([]);
    const [selectedStudent, setSelectedStudent] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedFeeHeads, setSelectedFeeHeads] = useState([]);
    const [paymentTypes, setPaymentTypes] = useState([]);
    const [showStudents, setShowStudents] = useState(false);
    const [otpModalOpen, setOtpModalOpen] = useState(false);
    const [studentResponse, setStudentResponse] = useState('')
    const [helpdeskperson, setHelpDeskPerson] = useState([]);
    const [selectedEmployeeIds, setSelectedEmployeeIds] = useState([]);

    const gethelpdeskPerson = async () => {
        const url = "finance/course-fee-plans/authorized-employees/?type=schedule";
        const response = await getData(url);
        setHelpDeskPerson(response?.authorized_employees)
    }

    const [sessions, setSessions] = useState([]);
    const [selectedSession, setSelectedSession] = useState(null);

    const getSessions = async () => {
        const response = await getData("academics/academic-years/");


        const options = response?.map((session) => ({
            value: session.id,
            label: session.name,
            is_current: session.is_current,
        }));

        setSessions(options);

        // Find the default session where is_current is true
        const currentSession = options.find((opt) => opt.is_current);

        if (currentSession) {
            setSelectedSession(currentSession);
        }
    };

    useEffect(() => {
        gethelpdeskPerson()
        getSessions();
    }, []);


    // const getFeeTypes = async (courseId) => {
    //     if (!courseId) return;
    //     const url = `finance/available-fee-head-types/${courseId}/`;
    //     const res = await getData(url);

    //     const options = res?.map((i) => ({
    //         label: i.name,
    //         value: i.id
    //     })) || [];
    //     setPaymentTypes([{ label: "Select All", value: "ALL" }, ...options]);
    // };

    useEffect(() => {
        if (!selectedCourse.length) {
            setPaymentTypes([]);
            return;
        }

        const fetchAllFeeTypes = async () => {
            const allFeeTypes = [];

            for (const courseOpt of selectedCourse) {
                const url = `finance/available-fee-head-types/${courseOpt.value}/`;
                const res = await getData(url);

                if (Array.isArray(res)) {
                    res.forEach(i => {
                        allFeeTypes.push({
                            courseId: courseOpt.value,
                            courseName: courseOpt.label,
                            label: `${i.name}`,
                            value: i.id
                        });
                    });
                }
            }

            // remove duplicates by fee id
            const uniqueFeeTypes = Array.from(
                new Map(allFeeTypes.map(f => [f.value, f])).values()
            );

            setPaymentTypes([{ label: "Select All", value: "ALL" }, ...uniqueFeeTypes]);
        };

        fetchAllFeeTypes();
    }, [selectedCourse]);



    const handleChange = (selected) => {
        if (!selected) {
            setSelectedFeeHeads([]);
            return;
        }

        // check if "Select All" is clicked
        if (selected.some((s) => s.value === "ALL")) {
            if (selectedFeeHeads.length === paymentTypes.length - 1) {
                setSelectedFeeHeads([]); // unselect all
            } else {
                // select all except "ALL"
                setSelectedFeeHeads(paymentTypes.filter((p) => p.value !== "ALL").map(p => p.value));
            }
        } else {
            setSelectedFeeHeads(selected.map(s => s.value));
        }
    };



    // Fetch specialization list whenever selectedSession changes
    useEffect(() => {
        // if (!selectedSession) return;
        // Reset state immediately when session changes
        // setSelectedCourse([]);
        // setSelectedSemester([]);
        // setSelectedSections([]);
        // setSemesterOptions([]);
        // setSectionOptions([]);
        // setStudents([]);
        // setAllCourseStudents([]);
        // setSelectedStudent([]);
        setShowStudents(false);
        const fetchData = async () => {
            // const query = `?academic_year_id=${selectedSession.value}`;
            const res = await getData(`finance/specializations/`);

            if (Array.isArray(res)) {
                setCourseData(res);
                setCourseOptions(res.map((c) => ({ value: c.id, label: c.full_name })));
            }


        };

        fetchData();
    }, []);

    // useEffect(() => {
    //     if (selectedCourse?.value) {
    //         getFeeTypes(selectedCourse.value);
    //     }
    // }, [selectedCourse]);



    // 🔹 When course changes → reset semesters/sections and collect students


    useEffect(() => {
        // 🔹 If NO course is selected → reset all filters
        if (!selectedCourse.length) {

            setSelectedSemester([]);
            setSelectedSections([]);
            setSelectedFeeHeads([]);
            setSemesterOptions([]);
            setSectionOptions([]);
            setPaymentTypes([]);
            setSearchTerm("");        // 🔥 RESET SEARCH
            setShowDueOnly(false);    // 🔥 RESET DUE FILTER
            setAllCourseStudents([]);
            setSelectedStudent([]);
            setStudents([]);
            setShowStudents(false)
            return;
        }


        if (!courseData.length) return;

        let groupedSemesters = [];
        let allStudents = [];

        selectedCourse.forEach(courseOpt => {
            const course = courseData.find(c => c.id === courseOpt.value);
            if (!course?.academic_groups) return;

            const semesterOptions = course.academic_groups.map(sem => ({
                value: sem.id,
                label: `${course.full_name} - ${sem.name}`,  // ✅ show course + semester
                courseId: course.id,
                courseName: course.full_name
            }));


            groupedSemesters.push({
                label: course.full_name, // Group header (e.g. B.A)
                options: semesterOptions // Grouped semesters
            });

            // Collect students as before
            course.academic_groups.forEach(semester => {
                semester.lags?.forEach(section => {
                    section.students?.forEach(stu => {
                        allStudents.push({
                            id: stu.user_id,
                            name: stu.full_name,
                            rollNumber: stu.permanent_registration_number,
                            semester: semester.id,
                            semesterName: semester.name,
                            section: section.id,
                            sectionName: section.name,
                            courseId: course.id,
                            balance: stu.balance,
                            courseName: course.full_name,
                            feeSchedules: stu.fee_schedules || []
                        });
                    });
                });
            });
        });

        setSemesterOptions(groupedSemesters); // ✅ grouped options
        setAllCourseStudents(allStudents);
        setStudents(allStudents);
        setSelectedStudent(allStudents.map(s => s.id));
        // setShowStudents(true);
    }, [selectedCourse, courseData]);



    // 🔹 Sections depend on semester
    useEffect(() => {
        if (!selectedSemester.length) {
            setSectionOptions([]);
            setSelectedSections([]);
            setStudents(allCourseStudents);
            return;
        }

        let groupedSections = [];

        selectedSemester.forEach((semOpt) => {
            courseData.forEach((course) => {
                const semesterData = course.academic_groups?.find((s) => s.id === semOpt.value);

                if (semesterData?.lags?.length) {
                    const sectionOptions = semesterData.lags.map((sec) => ({
                        value: sec.id,
                        label: `${course.full_name} - ${semesterData.name} - ${sec.name}`,  // ✅ show course + semester + section
                        semesterId: semesterData.id,
                        semesterName: semesterData.name,
                        courseId: course.id,
                        courseName: course.full_name,
                    }));

                    // group label: "B.A - Semester 1"
                    groupedSections.push({
                        label: `${course.full_name} - ${semesterData.name}`,
                        options: sectionOptions,
                    });
                }
            });
        });

        setSectionOptions(groupedSections);
        setSelectedSections([]);

        // ✅ Auto-filter students for selected semesters
        const semesterIds = selectedSemester.map((s) => s.value);
        const filteredBySemester = allCourseStudents.filter((stu) =>
            semesterIds.includes(stu.semester)
        );
        setStudents(filteredBySemester);
        setSelectedStudent(filteredBySemester.map((s) => s.id));
    }, [selectedSemester, courseData, allCourseStudents]);



    // SECTION selection
    useEffect(() => {
        if (!selectedSections.length) {
            if (selectedSemester) {
                const filteredBySemester = allCourseStudents.filter(stu => stu.semester === selectedSemester.value);
                setStudents(filteredBySemester);
                // setSelectedStudent(filteredBySemester.map(s => s.id));
            } else {
                setStudents(allCourseStudents);
                // setSelectedStudent(allCourseStudents.map(s => s.id));
            }
            return;
        }

        const sectionIds = selectedSections.map(s => s.value);
        const filteredBySection = allCourseStudents.filter(stu => sectionIds.includes(stu.section));
        setStudents(filteredBySection);
        // setSelectedStudent(filteredBySection.map(s => s.id));
    }, [selectedSections, allCourseStudents, selectedSemester]);

    const filteredStudents = useMemo(() => {
        // 🔥 If NO course selected → return full student list
        // If NO course selected → return allCourseStudents
        if (!selectedCourse.length) {
            return allCourseStudents;
        }
        let result = [...allCourseStudents];

        const courses = selectedCourse || [];
        const semesters = selectedSemester || [];
        const sections = selectedSections || [];
        const feeHeads = selectedFeeHeads || [];

        // 🔹 Filter by course
        if (courses.length) {
            const courseIds = courses.map(c => Number(c.value));
            result = result.filter(stu => courseIds.includes(stu.courseId));
        }

        // 🔹 Filter by semester
        if (semesters.length) {
            const semesterIds = semesters.map(s => Number(s.value));
            result = result.filter(stu => semesterIds.includes(stu.semester));
        }

        // 🔹 Filter by section
        if (sections.length) {
            const sectionIds = sections.map(s => s.value);
            result = result.filter(stu => sectionIds.includes(stu.section));
        }

        // 🔹 Filter by fee heads (new logic)
        if (feeHeads.length) {
            result = result.filter(stu => {
                // check if any of student's feeSchedules match selected fee heads
                return stu.feeSchedules?.some(fee => feeHeads.includes(Number(fee.fee_type_head_pk)));
            });
        }

        // 🔹 Filter by search term
        if (searchTerm) {
            const term = searchTerm.toLowerCase();
            result = result.filter(stu =>
                stu.name?.toLowerCase().includes(term) ||
                stu.rollNumber?.toLowerCase().includes(term) ||
                stu.mobile_number?.toString().includes(term) ||
                stu.email?.toLowerCase().includes(term)

            );
        }

        result.sort((a, b) => a.name.localeCompare(b.name));

        return result;
    }, [allCourseStudents, selectedCourse, selectedSemester, selectedSections, selectedFeeHeads, searchTerm]);


    const calculateSelectedAmount = (student) => {

        return (student.feeSchedules || [])
            .filter(fs => selectedFeeHeads.includes(Number(fs.fee_type_head_pk)))
            .reduce((sum, fs) => sum + parseFloat(fs.amount || 0), 0)
            .toFixed(2);
    };


    const canSelectStudent = (student) => {
        return filteredStudents.some(s => s.id === student.id);
    };

    const toggleAll = (e, studentsToSelect) => {
        if (e.target.checked) {
            const selectableIds = studentsToSelect.map(s => s.id);
            setSelectedStudent(selectableIds);

        } else {
            setSelectedStudent([]);

        }
    };

    const toggleBalanceDisplay = (studentId) => {
        setBalanceToggle(prev => ({ ...prev, [studentId]: !prev[studentId] }));
    };


    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [showPrintNoticeModal, setShowPrintNoticeModal] = useState(false);
    const [pendingCalculativePayload, setPendingCalculativePayload] = useState(null);
    const [noticeData, setNoticeData] = useState('')

    const [isSubmittingCalc, setIsSubmittingCalc] = useState(false);
    const [showWaittingModal, setShowWaitingModal] = useState(false)


    const [rows, setRows] = useState([{ copyTo: "", reason: "" }]);

    // Handle input change
    const handleChangeResonCopyto = (index, field, value) => {
        const updated = [...rows];
        updated[index][field] = value;
        setRows(updated);
    };

    // Add new row
    const handleAddRow = () => {
        setRows([...rows, { copyTo: "", reason: "" }]);
    };

    // Remove a row
    const handleRemoveRow = (index) => {
        setRows(rows.filter((_, i) => i !== index));
    };
    const selectedIds = rows.map((r) => r.copyTo).filter(Boolean);

    const [designations, setDesignations] = useState([]);

    // 🔹 Fetch designations
    const getDesignations = async () => {
        const res = await getData("administration/designations-no-pagination/");
        if (Array.isArray(res)) {
            const formatted = res.map((d) => ({
                value: d.id,
                label: d.name,
            }));
            setDesignations(formatted);
        }
    };



    useEffect(() => {
        getDesignations()
    }, [])









    const handleConfirmCalculative = async (payload) => {

        setIsSubmittingCalc(true);
        try {
            const uniqueFileName = uuidv4().replace(/-/g, "").slice(0, 20);
            const pdfBlob = await generateScheduledFeePDF(schedulePreviewData, uniqueFileName);


            // const fileUrl = await uploadToS3(pdfBlob, uniqueFileName);
            // if (!fileUrl) throw new Error("File upload failed — S3 URL not received.");

            // Determine approval URL based on planMode
            let approvalUrl = "";
            if (pendingCalculativePayload?.planMode === "course") {
                approvalUrl = `${process.env.REACT_APP_WINDOW_BASEURL2}fee/schedule-aprrovals-course-wise/${uniqueFileName}`;
            } else {
                approvalUrl = `${process.env.REACT_APP_WINDOW_BASEURL2}fee/schedule-aprrovals-course-wise/${uniqueFileName}`;
            }

            const payloadWithDoc = {
                ...pendingCalculativePayload,
                // document_url: fileUrl,
                // document_url: "https://data-storage.doubletick.io/org_uHfW62XVjF/templates/d7c554ca-a7a9-4750-bcce-ef8a8f043c32.pdf",
                document_uuid: uniqueFileName,
                approval_url: approvalUrl,
            };


            const formData = new FormData();
            formData.append("document_url", pdfBlob, `${uniqueFileName}.pdf`);

            // Append other fields from payload
            Object.entries(payloadWithDoc).forEach(([key, value]) => {
                if (typeof value === "object" && value !== null) {
                    formData.append(key, JSON.stringify(value));
                } else {
                    formData.append(key, value);
                }
            });
            const res = await Postdataform('finance/ledger-schedule-multiple-courses/', formData);

            if (res && res.unique_id) {
                // Notifier.success("OTP has been sent to the authorized person.");
                // setShowPrintNoticeModal(true);
                setNoticeData({
                    createdDate: res?.created_at,
                    uniqueId: res?.unique_id,
                    total_created: res?.total_created,
                    course_mode: res?.course_mode,
                    feeDetails: res.created_schedule_entries,
                    copy_to_details: rows
                        .filter(r => r.copyTo)
                        .map(r => {
                            const designationObj = designations.find(d => d.value === r.copyTo);
                            return {
                                id: r.copyTo,
                                designation: designationObj?.label || "",
                                reason: r.reason || "",
                            };
                        }),
                });
                setStudentResponse({
                    unique_id: res.unique_id,
                    // message: res.message,
                    otp: res.otps
                })
                // setOtpModalOpen(true)
                setShowWaitingModal(true)
                setSchedulePreviewOpen(false)
            } else if (res?.error) {
                // Show formatted error
                let errorMsg = res.error;

                if (Array.isArray(res.missing_schedules) && res.missing_schedules.length > 0) {
                    errorMsg += `<br/><br/>Missing schedules (${res.found_total}/${res.expected_total} found):<br/>`;
                    errorMsg += res.missing_schedules
                        .map((msg, i) => `${i + 1}. ${msg}`)
                        .join("<br/>");
                }

                setCalcPenaltyError(errorMsg);
                // Notifier.error(errorMsg.replace(/<br\/?>/g, '\n'));
            } else {
                // Generic fallback error
                setCalcPenaltyError('Something went wrong. Please try again.');
                Notifier.error('Something went wrong. Please try again.');
            }
        } catch (err) {
            console.error("Request failed:", err);
            setCalcPenaltyError('Something went wrong. Please try again.');
        } finally {
            setIsSubmittingCalc(false);  // 🔥 stop loader
        }
    };



    const handleCancelCalculative = () => {
        setShowConfirmModal(false);
        navigate(-1);
    };


    const handleCancelPrint = () => {
        setShowConfirmModal(false);
        navigate(-1)
    };


    // Calculative action UI state (no confirmation modal)
    const [showCalculativeAction, setShowCalculativeAction] = useState(false);
    const [calcDueNowChecked, setCalcDueNowChecked] = useState(false);
    const [calcScheduleLaterChecked, setCalcScheduleLaterChecked] = useState(false);
    const [calcInlineAction, setCalcInlineAction] = useState(''); // 'due' | 'later' | ''
    // scheduled date for calculative
    const [calcScheduledDate, setCalcScheduledDate] = useState('');
    // penalty toggle + amount specific to calculative
    const [calcImposePenalty, setCalcImposePenalty] = useState(false);
    const [calcPenaltyAmount, setCalcPenaltyAmount] = useState('');
    const [calcPenaltyError, setCalcPenaltyError] = useState('');
    const [calcPenaltyMaxAmount, setCalcPenaltyMaxAmount] = useState('');

    const calcPenaltyRef = useRef(null);
    const calcPenaltyInputRef = useRef(null);

    // exclusivity for Calculative choices
    const handleCalcSelectDueNow = () => {
        const newVal = !calcDueNowChecked;
        setCalcDueNowChecked(newVal);
        if (newVal) {
            setCalcScheduleLaterChecked(false);
            setCalcInlineAction('due');
        } else {
            setCalcInlineAction('');
        }
    };

    const handleCalcSelectScheduleLater = () => {
        const newVal = !calcScheduleLaterChecked;
        setCalcScheduleLaterChecked(newVal);
        if (newVal) {
            setCalcDueNowChecked(false);
            setCalcInlineAction('later');
        } else {
            setCalcInlineAction('');
        }
    };

    const resetCalculativeAction = () => {
        setShowCalculativeAction(false);
        setCalcDueNowChecked(false);
        setCalcScheduleLaterChecked(false);
        setCalcInlineAction('');
        setCalcScheduledDate('');
        setCalcImposePenalty(false);
        setCalcPenaltyAmount('');
        setCalcPenaltyError('');
        setMaxPenaltyAmount('')
    };

    const [individualAmount, setIndividualAmount] = useState()
    const [schedulePreviewOpen, setSchedulePreviewOpen] = useState(false);
    const [schedulePreviewData, setSchedulePreviewData] = useState(null);



    const handleCalculativeSubmit = async () => {
        // --- Validations ---
        if (!calcInlineAction) {
            setCalcPenaltyError('Choose Due now or Schedule for later');
            return;
        }
        if (calcInlineAction === 'later') {
            if (!calcScheduledDate) {
                setCalcPenaltyError('Please pick a scheduled date');
                return;
            }
            const sel = new Date(calcScheduledDate);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            if (sel < today) {
                setCalcPenaltyError('Scheduled date cannot be in the past');
                return;
            }
        }
        if (calcImposePenalty) {
            const n = Number(calcPenaltyAmount);
            if (calcPenaltyAmount === '' || Number.isNaN(n) || n <= 0) {
                setCalcPenaltyError('Enter a valid penalty amount greater than 0');
                return;
            }
            if (n > calcPenaltyMaxAmount) {
                setCalcPenaltyError(
                    `Penalty per day cannot be greater than the maximum penalty amount (₹${calcPenaltyMaxAmount}).`
                );
                return;
            }
            // if (n > 2000) {
            //     setCalcPenaltyError('Penalty cannot be more than ₹2000');
            //     setCalcPenaltyAmount('2000');
            //     return;
            // }
        }

        if (!selectedStudent.length) {
            setCalcPenaltyError('Please select at least one student');
            return;
        }

        // ✅ Filter only selected + visible
        const studentIds = selectedStudent.filter(id =>
            filteredStudents.some(stu => stu.id === id)
        );

        if (!studentIds.length) {
            setCalcPenaltyError('Please select at least one student');
            return;
        }

        const todayDate = new Date().toISOString().split('T')[0];
        const dueDate = calcInlineAction === 'later' ? calcScheduledDate : todayDate;

        const visibleStudents = showDueOnly
            ? filteredStudents.filter(s => s.balance < 0)
            : filteredStudents;


        const isAllSelected =
            visibleStudents.length > 0 &&
            selectedStudent.length === visibleStudents.length;

        // ✅ Only compare visible students with actually selected visible students
        // const isAllSelected =
        //     visibleStudents.length > 0 &&
        //     studentIds.length === visibleStudents.length;

        const dynamicPlanMode = isAllSelected ? "course" : "individual";

        // 👉 Build per-student headwise amounts

        const studentFeeAmounts = studentIds.map(id => {
            const stu = filteredStudents.find(s => s.id === id);
            const headWise = {};

            if (stu?.feeSchedules) {
                selectedFeeHeads.forEach(feeHeadId => {
                    const head = stu.feeSchedules.find(h => String(h.fee_type_head_pk) === String(feeHeadId));
                    if (head) {
                        headWise[feeHeadId] = head.amount || head.balance || 0; // pick correct field
                    }
                });
            }

            return {
                student_id: id,
                heads: headWise,
            };
        });

        const payload = {
            student_ids: studentIds.join(','),
            fee_head_ids: selectedFeeHeads.join(','),
            lag_ids: selectedSemester?.map(s => s.value).join(',') || null,
            due_date: dueDate,
            penalty_per_day: calcImposePenalty ? Number(calcPenaltyAmount) : 0,
            max_penalty: calcImposePenalty ? Number(calcPenaltyMaxAmount) : 0,
            plan_mode: dynamicPlanMode,
            employee_ids: selectedEmployeeIds.join(","),
            copy_to_details: rows
                .filter(r => r.copyTo) // only include filled rows
                .map(r => ({
                    designation_id: r.copyTo,
                    reason: r.reason || "",
                })),

        };

        const selectedFeeHeadNames = paymentTypes
            .filter(p => selectedFeeHeads.includes(p.value))
            .map(p => p.label);
        const selectedStudentsData = filteredStudents.filter(stu => studentIds.includes(stu.id));

        setPendingCalculativePayload(payload);
        setSchedulePreviewData({
            payload,
            selectedCourse,
            selectedSemester,
            selectedStudents: selectedStudentsData,
            filteredStudents,
            dueDate,
            calcImposePenalty,
            calcPenaltyAmount,
            calcPenaltyMaxAmount,
            selectedFeeHeadNames,
            paymentTypes,
            student_fee_amounts: studentFeeAmounts,
            copyToData: rows, // [{ copyTo: designationId, reason: "..." }, ...]
            copyToDisplayData: rows.map(r => ({
                designation: designations.find(d => d.value === r.copyTo)?.label || "",
                reason: r.reason
            }))
        });

        setSchedulePreviewOpen(true); // 👉 open preview modal
        // setShowConfirmModal(true);
    };




    useEffect(() => {
        if (!calcImposePenalty) return;
        const t = setTimeout(() => {
            const el = calcPenaltyRef.current;
            if (el) try { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { try { el.scrollIntoView() } catch (e) { } }
            const input = calcPenaltyInputRef.current;
            if (input) try { input.focus(); } catch (e) { }
        }, 120);
        return () => clearTimeout(t);
    }, [calcImposePenalty]);







    // Inline penalty input state (shown after user confirms "Yes")
    const [showInlinePenalty, setShowInlinePenalty] = useState(false);


    // scroll into view + focus when inline penalty shows — safe version with cleanup
    useEffect(() => {
        if (!showInlinePenalty) return;

        const timer = setTimeout(() => {
            const el = penaltyRef.current;
            if (el) {
                try {
                    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                } catch (err) {
                    // fallback if options not supported
                    try { el.scrollIntoView(); } catch (e) { /* ignore */ }
                }
            }

            const inputEl = penaltyInputRef.current;
            if (inputEl) {
                try { inputEl.focus(); } catch (e) { /* ignore */ }

                // guard setSelectionRange — not supported on number inputs
                try {
                    if (typeof inputEl.setSelectionRange === 'function' && inputEl.type !== 'number') {
                        const val = inputEl.value || '';
                        inputEl.setSelectionRange(val.length, val.length);
                    }
                } catch (e) {
                    // ignore
                }
            }
        }, 120);

        return () => clearTimeout(timer);
    }, [showInlinePenalty]);

    // refs for scrolling/focus
    const penaltyRef = useRef(null);
    const penaltyInputRef = useRef(null);
    const [showInlineFixedForm, setShowInlineFixedForm] = useState(false);

    const [maxPenaltyAmount, setMaxPenaltyAmount] = useState('');

    // refs for focus/scroll
    const fixedFormRef = useRef(null);
    const fixedFeeHeadRef = useRef(null);

    // scroll into view & focus feeHead when inline fixed form opens — safe version with cleanup
    useEffect(() => {
        if (!showInlineFixedForm) return;

        const timer = setTimeout(() => {
            const el = fixedFormRef.current;
            if (el) {
                try {
                    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                } catch (err) {
                    try { el.scrollIntoView(); } catch (e) { /* ignore */ }
                }
            }

            const inputEl = fixedFeeHeadRef.current;
            if (inputEl) {
                try { inputEl.focus(); } catch (e) { /* ignore */ }
            }
        }, 120);

        return () => clearTimeout(timer);
    }, [showInlineFixedForm]);



    const navigate = useNavigate()
    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = (student) => {
        setSelectedStudent(student);
        setIsModalOpen(true);
    };
    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedStudent(null);
    };
    const handelShowAdditionalFeePlan = (student) => {
        setSelectedStudent(student);  // store the clicked student in state
        setIsModalOpen(true);
    };




    // const displayedStudents = (showDueOnly
    //     ? filteredStudents.filter(s => s.balance < 0)
    //     : filteredStudents
    // ).filter(canSelectStudent);

    const displayedStudents = showDueOnly
        ? filteredStudents.filter(s => s.balance < 0)
        : filteredStudents;

    const totalFeePlanAmount = displayedStudents.reduce((acc, s) => {
        if (selectedFeeHeads.length === 0) return acc;

        const filteredSchedules = s.feeSchedules?.filter(fs => {
            const feeHeadMatch = selectedFeeHeads.includes(Number(fs.fee_type_head_pk));
            const sectionMatch = selectedSemester?.length
                ? selectedSemester.some(sem => Number(sem.value) === Number(fs.academic_group_pk))
                : true;

            return feeHeadMatch && sectionMatch;
        }) || [];

        const total = filteredSchedules.reduce(
            (sum, fs) => sum + parseFloat(fs.amount || 0),
            0
        );

        return acc + total;
    }, 0);






    const handleConfirmOtp = async (otpCode) => {
        // if (!studentResponse?.unique_id) {

        //     console.error("No unique_id found in studentResponse:", studentResponse);
        //     Notifier.error("Student Unique ID is missing. Cannot verify OTP.");
        //     return;
        // }

        const url = 'finance/verify-ledger-schedule/';
        const payload = {
            unique_id: studentResponse.unique_id,
            otp: otpCode
        };

        try {
            const response = await Postdata(url, payload);
            // Check if API returned an error in the response
            if (response?.error) {
                Notifier.error(response.error); // show error from API
                return; // stop further execution
            }

            // Success path
            Notifier.success("Fee schedule & Due created successfully");
            setOtpModalOpen(false);
            setShowConfirmModal(true)
            // navigate(-1);
        } catch (error) {
            console.error("Error verifying OTP:", error);
            Notifier.error(error?.message || "Failed to verify OTP");
        }
    };

    // Step 5: Cancel OTP modal
    const handleCancelOtp = () => {
        setOtpModalOpen(false);
        navigate(-1)
    };






    const handlesResendOtpToAssignedPerson = async () => {
        const url = 'finance/resend-ledger-schedule-otp/';
        const payload = {
            unique_id: studentResponse.unique_id,
            employee_ids: selectedEmployeeIds.join(",")
        };

        try {
            const response = await Postdata(url, payload);
            if (!response?.error) {
                setStudentResponse({ otp: response.otps, unique_id: response.unique_id })
                Notifier.success(response.message || "OTP resent successfully!");
            } else {
                Notifier.error(response.message || "Failed to resend OTP.");
            }
        } catch (error) {

            const errorMessage =
                error?.response?.data?.message ||
                error?.message ||
                "Something went wrong. Please try again.";
            Notifier.error(errorMessage);
        }
    };

    return (
        <>

            <div style={{
                display: "flex",
                flexDirection: "column",
                height: "100vh",
                overflow: "hidden",
            }}>


                <div style={{ flexShrink: 0, padding: "0 12px" }}>
                    {/* Left side: SVG + heading */}
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <button
                            onClick={() => navigate(-1)}
                            style={{ background: "transparent", border: "none", cursor: "pointer", padding: 0 }}
                            title="Go back"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="32"
                                height="32"
                                fill="none"
                                stroke="#7F56DA"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <line x1="19" y1="12" x2="5" y2="12"></line>
                                <polyline points="12 19 5 12 12 5"></polyline>
                            </svg>
                        </button>
                        <h2 className='main-heading' style={{ margin: 0, color: "#7F56DA" }}>Add Schedule</h2>
                    </div>

                    {/* Right side: Academic Year */}
                    {/* <div>
                        <label className="form-labell">Admission Academic Year</label>
                        <Select
                            options={sessions}
                            value={selectedSession}
                            onChange={opt => setSelectedSession(opt)}
                            styles={reactSelectStyles}
                            placeholder="Select Session"
                            // isClearable
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                        // isDisabled={true}
                        />

                    </div> */}
                </div>



                <div 
                className='scheduleconainer'
                style={{
                    flex: 1,
                    overflowY: "auto",
                    overflowX: "hidden",
                    minHeight: 0,
                    padding: "12px",
                    scrollbarGutter: "stable",
                }}>


                    <div className="row mt-3 d-flex justify-content-start align-items-center">



                        <div className="col-md-4">
                            <label className="form-labell">Select Course <span className="astrisk">*</span></label>
                            <Select
                                value={selectedCourse}
                                onChange={(opt) => setSelectedCourse(opt)}
                                options={courseOptions}
                                styles={reactSelectStyles}
                                placeholder="Select Course"
                                isClearable
                                menuPortalTarget={document.body}   // 🔹 Render menu at body level
                                menuPosition="fixed"
                                isMulti
                            />
                        </div>
                        {/* Semesters select (multi) - depends on selectedCourse */}
                        <div className="col-md-4">
                            <label className="form-labell">Select Semester<span className="astrisk">*</span></label>
                            <Select
                                value={selectedSemester}               // for multi-select, this should be an array
                                onChange={(options) => setSelectedSemester(options || [])} // store array of selected semesters
                                options={semesterOptions}              // ✅ grouped by course
                                styles={reactSelectStyles}
                                placeholder="Select Semester"
                                isDisabled={!selectedCourse.length}

                                isMulti                                // ✅ enable multi-select
                                // isDisabled={!semesterOptions.length}
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                formatGroupLabel={(group) => (
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            fontWeight: 700,
                                            fontSize: '15px',
                                            color: '#222',
                                            // background: '#f3f3f3',
                                            padding: '6px 10px',
                                            borderBottom: '1px solid #ddd',
                                            borderRadius: '4px',
                                        }}
                                    >
                                        {group.label}
                                        {/* <span style={{ fontSize: '12px', color: '#666' }}>
                                                ({group.options.length})
                                            </span> */}
                                    </div>
                                )}
                            />

                        </div>
                        {/* Toggle Tabs */}





                        {/* Sections select (multi) - depends on selectedSemesters */}
                        <div className="col-md-4">
                            <label className="form-labell">Select Section(s) <span className="astrisk">*</span></label>
                            <Select
                                value={selectedSections}
                                onChange={(options) => setSelectedSections(options || [])}
                                options={sectionOptions} // ✅ grouped
                                styles={reactSelectStyles}
                                placeholder="Select Section"
                                isMulti
                                isDisabled={!sectionOptions.length}
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                formatGroupLabel={(group) => (
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            fontWeight: 700,
                                            fontSize: '15px',
                                            color: '#222',
                                            // background: '#f3f3f3',
                                            padding: '6px 10px',
                                            borderBottom: '1px solid #ddd',
                                            borderRadius: '4px',
                                        }}
                                    >
                                        {group.label}
                                        {/* <span style={{ fontSize: '12px', color: '#666' }}>
                                                ({group.options.length})
                                            </span> */}
                                    </div>
                                )}
                            />


                        </div>
                    </div>



                    <div className=' '>


                        {!selectedCourse ? (
                            <div
                                className="col-12 d-flex flex-column align-items-center justify-content-center mt-5 sections"
                                style={{ minHeight: 420, textAlign: 'center', color: '#6c757d' }}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="80"
                                    height="80"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#6c757d"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                >
                                    <path d="M21 21l-4.35-4.35"></path>
                                    <circle cx="10" cy="10" r="7"></circle>
                                    <line x1="14" y1="10" x2="14" y2="10"></line>
                                </svg>
                                <p className="mt-3" style={{ fontSize: '18px', fontWeight: 500 }}>
                                    No records found
                                </p>
                                <p className="text-muted" style={{ fontSize: '14px' }}>
                                    Please select a course to view students.
                                </p>
                            </div>
                        ) : (
                            <>

                                <div className="row sections mt-3">
                                    <div className="col-md-3  ">

                                        <label className="form-labell">
                                            Select Fee Head(s) <span className="astrisk">*</span>
                                        </label>
                                        <Select
                                            isMulti
                                            styles={reactSelectStyles}
                                            options={paymentTypes}
                                            value={paymentTypes.filter(p => selectedFeeHeads.includes(p.value))}
                                            onChange={handleChange}
                                            placeholder="Search or select fee heads..."
                                            menuPortalTarget={document.body} // Render dropdown at body level
                                            menuPosition="fixed"
                                        // closeMenuOnSelect={false}
                                        />
                                    </div>
                                    <div className="col-md-12 d-flex align-items-center gap-2 mt-3 mb-3">
                                        <div className="form-check form-switch custom-switch">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                role="switch"
                                                style={{ cursor: 'pointer' }}
                                                checked={showStudents} // controlled by state
                                                onChange={() => setShowStudents(prev => !prev)} // toggle
                                            />
                                            <label className="form-check-label">
                                                {showStudents ? "Hide Student List" : "Show Student List"}
                                            </label>
                                        </div>
                                    </div>
                                </div>


                                <div className="row mt-4">

                                    {showStudents && (
                                        <div className="col-12">
                                            <div className="mt-4 d-flex justify-content-between align-items-center">
                                                <h5>
                                                    Select Students{" "}
                                                    <span className="text-muted small" style={{ fontSize: "14px" }}>
                                                        (
                                                        {
                                                            selectedStudent.filter(id =>
                                                                filteredStudents.some(stu => stu.id === id)
                                                            ).length
                                                        }
                                                        / {filteredStudents.length} selected)
                                                    </span>
                                                </h5>

                                                {planMode === 'course' && (<div className='d-flex flex-row justify-content-end'>
                                                    <p style={{ fontWeight: 'bold' }}>Total Amount₹ {totalFeePlanAmount.toLocaleString('en-IN')}</p>
                                                </div>)}
                                            </div>
                                            <div className="feePlanTableContainer mt-3" style={{ maxHeight: '400px', overflowY: 'auto', flexShrink: '0' }}>
                                                <table className="table table-bordered mt-2 feeplantables">
                                                    <thead
                                                        style={{ position: "sticky", top: 0, background: "#fff", zIndex: 2 }}
                                                    >
                                                        <tr>
                                                            {/* Master checkbox */}

                                                            <th style={{ width: 40 }}>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={
                                                                        (showDueOnly
                                                                            ? filteredStudents.filter(s => s.balance < 0).length > 0
                                                                            : filteredStudents.length > 0) &&
                                                                        selectedStudent.length ===
                                                                        (showDueOnly
                                                                            ? filteredStudents.filter(s => s.balance < 0).length
                                                                            : filteredStudents.length)
                                                                    }
                                                                    onChange={(e) =>
                                                                        toggleAll(
                                                                            e,
                                                                            showDueOnly
                                                                                ? filteredStudents.filter(s => s.balance < 0)
                                                                                : filteredStudents
                                                                        )
                                                                    }
                                                                />
                                                            </th>




                                                            {/* Student name + search */}
                                                            <th
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    gap: '8px',
                                                                    justifyContent: 'space-between'
                                                                }}
                                                            >
                                                                Student Name (Registration No.)
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Search students by name,registraion number,mobile number.."
                                                                    value={searchTerm}
                                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                                    style={{ maxWidth: '480px', height: '30px', fontSize: '14px' }}
                                                                />
                                                            </th>

                                                            <th>Course</th>

                                                            {/* Balance + Due only toggle */}
                                                            <th className="text-end">
                                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                                                                    <span>Balance</span>
                                                                    <label
                                                                        style={{
                                                                            display: 'inline-flex',
                                                                            alignItems: 'center',
                                                                            gap: 6,
                                                                            fontSize: 12,
                                                                            fontWeight: 500,
                                                                            color: '#666'
                                                                        }}
                                                                    >
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={showDueOnly}
                                                                            onChange={() => setShowDueOnly(prev => !prev)}
                                                                            style={{ width: 14, height: 14, cursor: 'pointer' }}
                                                                        />
                                                                        Due only
                                                                    </label>
                                                                </div>
                                                            </th>

                                                            {/* Scheduled amount */}
                                                            <th className="text-end">
                                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                                                                    <span>Amount as per Fee Impose</span>
                                                                </div>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {filteredStudents.length === 0 ? (
                                                            <tr>
                                                                <td colSpan={5} className="text-center text-muted py-3">
                                                                    No students found for the selected filters.
                                                                </td>
                                                            </tr>
                                                        ) : (
                                                            filteredStudents.map((s) => (
                                                                <tr key={s.id}>

                                                                    <td>
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={selectedStudent.includes(s.id)}
                                                                            onChange={(e) => {
                                                                                if (e.target.checked) {
                                                                                    setSelectedStudent([...selectedStudent, s.id]);
                                                                                } else {
                                                                                    setSelectedStudent(selectedStudent.filter(id => id !== s.id));

                                                                                }
                                                                            }}
                                                                        />

                                                                    </td>
                                                                    <td>{s.name} ({s.rollNumber})</td>

                                                                    <td>{s?.courseName} | {s.semesterName} | {s.sectionName}</td>
                                                                    <td className="text-end" style={{ color: s.balance > 0 ? "green" : "red" }}>
                                                                        {s.balance}₹
                                                                    </td>
                                                                    <td className="text-end">
                                                                        {calculateSelectedAmount(s)} ₹
                                                                    </td>


                                                                </tr>
                                                            ))
                                                        )}
                                                    </tbody>




                                                </table>

                                            </div>


                                        </div>)}

                                    {/* Calculative action panel - shown automatically when at least one student selected */}
                                    {selectedStudent.length > 0 && (
                                        <div className="mt-3 p-3 border rounded" style={{ background: '#fafafa' }}>
                                            {planMode === 'individual' && (
                                                <div className=" row d-flex justify-content-start align-items-center mb-2 " >
                                                    {/* <div className='col-md-2'>
                                                <span>  Amount to be scheduled</span>
                                            </div> */}
                                                    <div className='col-md-2'>
                                                        <span className=''>  Amount to be scheduled<span className="astrisk">*</span></span>
                                                        <input
                                                            type="text"
                                                            className="form-control mt-1"
                                                            placeholder="Scheduled Amount"
                                                            value={individualAmount}
                                                            onChange={(e) => {
                                                                let value = e.target.value;
                                                                if (/^\d*\.?\d{0,2}$/.test(value)) {
                                                                    setIndividualAmount(value);
                                                                }
                                                            }}
                                                            style={{ height: "35px" }}
                                                            onKeyDown={(e) => {
                                                                if (
                                                                    !(
                                                                        (e.key >= "0" && e.key <= "9") || // digits
                                                                        e.key === "." ||                  // dot
                                                                        e.key === "Backspace" ||          // backspace
                                                                        e.key === "ArrowLeft" ||          // navigation
                                                                        e.key === "ArrowRight" ||
                                                                        e.key === "Tab"
                                                                    )
                                                                ) {
                                                                    e.preventDefault();
                                                                }
                                                            }}
                                                        /></div>

                                                </div>)}
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <strong>Schedule Options</strong>
                                                <div style={{ textAlign: 'right' }}>

                                                    <small className="text-muted">
                                                        {selectedStudent.filter(id => filteredStudents.some(stu => stu.id === id)).length}{" "}
                                                        {selectedStudent.length === 1 ? "student" : "students"} selected
                                                    </small>

                                                    <div className="small text-muted">Uncheck selected students to close</div>
                                                </div>
                                            </div>

                                            <div className="d-flex gap-4 align-items-start">
                                                {/* Left Side: Due now and Scheduled Date */}
                                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                    {/* Due now */}
                                                    <label style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={calcDueNowChecked}
                                                            onChange={handleCalcSelectDueNow}
                                                            disabled={selectedStudent.length === 0}
                                                        />
                                                        <span>Due now</span>
                                                    </label>

                                                    {/* Scheduled Date under Due now */}
                                                    {calcInlineAction === 'later' && (
                                                        <div className="mt-2">
                                                            <label className="form-labell mb-1">
                                                                Scheduled Date <span className="astrisk">*</span>
                                                            </label>
                                                            <input
                                                                type="date"
                                                                value={calcScheduledDate}
                                                                className="form-control penalityInput"
                                                                onChange={(e) => {
                                                                    setCalcScheduledDate(e.target.value);
                                                                    setCalcPenaltyError('');
                                                                }}
                                                                min={new Date().toISOString().split('T')[0]}

                                                            />
                                                        </div>
                                                    )}
                                                </div>

                                                {/* Right Side: Schedule for later */}
                                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                    <label style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={calcScheduleLaterChecked}
                                                            onChange={handleCalcSelectScheduleLater}
                                                            disabled={selectedStudent.length === 0}
                                                        />
                                                        <span>Schedule for later</span>
                                                    </label>
                                                </div>
                                            </div>
                                            {/* penalty toggle */}
                                            <div className="mt-3">
                                                <label style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={calcImposePenalty}
                                                        onChange={(e) => {
                                                            const checked = e.target.checked;
                                                            setCalcImposePenalty(checked);
                                                            if (!checked) {
                                                                setCalcPenaltyAmount('');
                                                                setCalcPenaltyError('');
                                                            }
                                                        }}
                                                    />
                                                    <span>In case of payment default, do you want to impose a penalty?</span>
                                                </label>
                                            </div>

                                            {calcImposePenalty && (
                                                <div ref={calcPenaltyRef} className="row mt-3">

                                                    {/* Penalty per day input */}
                                                    <div className="col-md-3">
                                                        <label className="form-labell mb-1">Penalty per day in (₹)</label>
                                                        <input
                                                            ref={calcPenaltyInputRef}
                                                            type="number"
                                                            min="0"
                                                            step="0.01"
                                                            value={calcPenaltyAmount}
                                                            onChange={(e) => {
                                                                let value = e.target.value;

                                                                // Allow empty or up to 5 digits before decimal & 2 after
                                                                if (/^\d{0,5}(\.\d{0,2})?$/.test(value) || value === "") {
                                                                    setCalcPenaltyAmount(value);
                                                                    setCalcPenaltyError(""); // clear error when typing
                                                                }
                                                            }}


                                                            className="form-control penalityInput"
                                                            placeholder="Penalty per day"
                                                        />

                                                        <small className="text-muted">Penalty must not exceed the max amount</small>
                                                        {calcPenaltyError && <div className="text-danger small mt-1">{calcPenaltyError}</div>}
                                                    </div>

                                                    {/* Maximum penalty input */}
                                                    <div className="col-md-3">
                                                        <label className="form-labell mb-1">Maximum penalty amount (up to ₹)</label>

                                                        <input
                                                            type="number"
                                                            step="0.01"
                                                            value={calcPenaltyMaxAmount === null ? "" : calcPenaltyMaxAmount}
                                                            onChange={(e) => {
                                                                const value = e.target.value;

                                                                if (value === "") {
                                                                    setCalcPenaltyMaxAmount(null); // keep it empty
                                                                    setCalcPenaltyError("");
                                                                    return;
                                                                }

                                                                // Allow only up to 5 digits before decimal & 2 digits after
                                                                if (/^\d{0,5}(\.\d{0,2})?$/.test(value)) {
                                                                    const maxValue = parseFloat(value);
                                                                    setCalcPenaltyMaxAmount(maxValue);

                                                                    if (calcPenaltyAmount > maxValue) {
                                                                        setCalcPenaltyError("Penalty per day cannot be greater than the maximum penalty amount.");
                                                                    } else {
                                                                        setCalcPenaltyError("");
                                                                    }
                                                                }
                                                            }}
                                                            className="form-control penalityInput"
                                                            placeholder="Maximum penalty"
                                                        />

                                                    </div>
                                                </div>
                                            )}

                                            <div className='row'>
                                                <div className="col-md-4" style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: '16px' }}>
                                                    <div style={{ flex: 1 }}>
                                                        <label className="form-labell mb-2">
                                                            Schedule Approved By<span className="astrisk">*</span>
                                                        </label>
                                                        <Select
                                                            classNamePrefix="select"
                                                            isSearchable
                                                            isMulti
                                                            name="employees"
                                                            options={helpdeskperson?.map(emp => ({
                                                                value: emp.id,
                                                                label: emp.name,
                                                            }))}
                                                            placeholder="-- Select Employees --"
                                                            value={
                                                                helpdeskperson
                                                                    ?.map(emp => ({
                                                                        value: emp.id,
                                                                        label: emp.name,
                                                                    }))
                                                                    .filter(option => selectedEmployeeIds.includes(option.value)) // ✅ handle multiple
                                                            }
                                                            onChange={(selectedOptions) =>
                                                                setSelectedEmployeeIds(selectedOptions?.map(opt => opt.value) || [])
                                                            }
                                                            menuPortalTarget={document.body}
                                                            styles={reactSelectStyles}
                                                            menuPlacement="auto"
                                                            menuPosition="absolute"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            {rows.map((row, index) => {
                                                const filteredOptions = designations.filter(
                                                    (d) => !selectedIds.includes(d.value) || d.value === row.copyTo
                                                );
                                                return (<div className="row align-items-end mb-3" key={index}>
                                                    {/* Copy To */}
                                                    <div className="col-md-4">
                                                        <label className="form-labell">Copy To</label>
                                                        <Select
                                                            options={filteredOptions}
                                                            value={designations.find((d) => d.value === row.copyTo) || null}
                                                            onChange={(selectedOption) =>
                                                                handleChangeResonCopyto(index, "copyTo", selectedOption?.value)
                                                            }
                                                            placeholder="Select designation"
                                                            styles={{
                                                                ...reactSelectStyles,
                                                                control: (base, state) => ({
                                                                    ...reactSelectStyles.control?.(base, state),
                                                                    minHeight: "50px",
                                                                }),
                                                            }}

                                                            menuPosition="absolute"


                                                            menuPlacement="auto"
                                                        />
                                                    </div>

                                                    {/* Reason */}
                                                    <div className="col-md-4">
                                                        <label className="form-labell">Reason</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter reason"
                                                            style={{ height: "45px" }}
                                                            value={row.reason}
                                                            onChange={(e) => handleChangeResonCopyto(index, "reason", e.target.value)}
                                                        />
                                                    </div>

                                                    {/* Buttons */}
                                                    <div className="col-md-4 d-flex align-items-center">
                                                        {rows.length > 1 && (
                                                            <button
                                                                onClick={() => handleRemoveRow(index)}
                                                                style={{ background: "none", border: "none", padding: 0 }}
                                                                title="Remove"
                                                            >
                                                                <svg width="17" height="17" viewBox="0 0 24 24" fill="none">
                                                                    <path
                                                                        d="M3 6H5H21"
                                                                        stroke="red"
                                                                        strokeWidth="2"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    />
                                                                    <path
                                                                        d="M8 6V4C8 3.44772 8.44771 3 9 3H15C15.5523 3 16 3.44772 16 4V6M19 6V20C19 21.1046 18.1046 22 17 22H7C5.89543 22 5 21.1046 5 20V6H19Z"
                                                                        stroke="red"
                                                                        strokeWidth="2"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    />
                                                                    <path
                                                                        d="M10 11V17"
                                                                        stroke="red"
                                                                        strokeWidth="2"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    />
                                                                    <path
                                                                        d="M14 11V17"
                                                                        stroke="red"
                                                                        strokeWidth="2"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    />
                                                                </svg>
                                                            </button>
                                                        )}
                                                    </div>


                                                    <div className="col-md-2">
                                                        {index === rows.length - 1 && (
                                                            <button
                                                                type="button"
                                                                className="btn mt-2"
                                                                onClick={handleAddRow}
                                                                style={{ border: "none", color: "#7F56DA" }}
                                                            >
                                                                <svg width="16" height="16" viewBox="0 0 22 23" fill="none">
                                                                    <path
                                                                        d="M20.4286 13.3537H12.5714V21.2108C12.5714 21.6276 12.4059 22.0273 12.1112 22.322C11.8165 22.6167 11.4168 22.7822 11 22.7822C10.5832 22.7822 10.1835 22.6167 9.88883 22.322C9.59413 22.0273 9.42857 21.6276 9.42857 21.2108V13.3537H1.57143C1.15466 13.3537 0.754961 13.1881 0.460261 12.8934C0.165561 12.5987 0 12.199 0 11.7822C0 11.3655 0.165561 10.9658 0.460261 10.6711C0.754961 10.3764 1.15466 10.2108 1.57143 10.2108H9.42857V2.35366C9.42857 1.93689 9.59413 1.53719 9.88883 1.24249C10.1835 0.947787 10.5832 0.782227 11 0.782227C11.4168 0.782227 11.8165 0.947787 12.1112 1.24249C12.4059 1.53719 12.5714 1.93689 12.5714 2.35366V10.2108H20.4286C20.8453 10.2108 21.245 10.3764 21.5397 10.6711C21.8344 10.9658 22 11.3655 22 11.7822C22 12.199 21.8344 12.5987 21.5397 12.8934C21.245 13.1881 20.8453 13.3537 20.4286 13.3537Z"
                                                                        fill="currentColor"
                                                                    />
                                                                </svg>
                                                                <span className="ms-2">Add More</span>
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>)
                                            })}

                                            {/* errors */}
                                            {calcPenaltyError && !calcImposePenalty && (
                                                <div
                                                    className="text-danger mt-2"
                                                    dangerouslySetInnerHTML={{ __html: calcPenaltyError }}
                                                />
                                            )}

                                            <div className="mt-3 d-flex gap-2 justify-content-end">
                                                <button className="btn btn-secondary" onClick={() => { resetCalculativeAction(); }}
                                                    style={{ padding: '6px 40px' }}>Cancel</button>
                                                <button
                                                    className="add-btn"
                                                    style={{
                                                        padding: '6px 40px',
                                                        cursor: !selectedEmployeeIds.length ||
                                                            !calcInlineAction ||
                                                            (calcInlineAction === 'later' && !calcScheduledDate) ||
                                                            (calcImposePenalty && (!calcPenaltyAmount || Number(calcPenaltyAmount) <= 0)) ||
                                                            selectedStudent.length === 0
                                                            ? 'not-allowed'
                                                            : 'pointer',
                                                        opacity: !selectedEmployeeIds.length ||
                                                            !calcInlineAction ||
                                                            (calcInlineAction === 'later' && !calcScheduledDate) ||
                                                            (calcImposePenalty && (!calcPenaltyAmount || Number(calcPenaltyAmount) <= 0)) ||
                                                            selectedStudent.length === 0
                                                            ? 0.6
                                                            : 1
                                                    }}
                                                    onClick={handleCalculativeSubmit}
                                                    disabled={
                                                        !selectedEmployeeIds.length ||
                                                        !calcInlineAction ||
                                                        (calcInlineAction === 'later' && !calcScheduledDate) ||
                                                        (calcImposePenalty && (!calcPenaltyAmount || Number(calcPenaltyAmount) <= 0)) ||
                                                        selectedStudent.length === 0
                                                    }
                                                >
                                                    Schedule fee
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div></>)}
                    </div>

                </div>
            </div>

            <FeePlanModal
                isOpen={isModalOpen}
                onClose={closeModal}
                studentName={selectedStudent?.student_name}
                feePlan={selectedStudent}
                setWidth="30%"
                selectedFeeHeads={selectedFeeHeads}
                setSelectedFeeHeads={setSelectedFeeHeads}
            />

            <ConfirmationModal
                isOpen={showConfirmModal}
                title="Confiramtion"
                message="Do you want to  print  the notice?"
                showCheckbox={true} // only here
                checkboxLabel="Print the notice as well"
                onConfirm={(isChecked) => {
                    if (isChecked) {
                        // ✅ open print modal
                        setShowPrintNoticeModal(true);
                    } else {
                        // ❌ not checked → navigate back
                        navigate(-1);
                    }
                    setShowConfirmModal(false); // always close confirm modal
                }}
                onCancel={handleCancelCalculative}
                isSubmitting={isSubmittingCalc}
            />

            <ScheduleFeePreview
                isOpen={schedulePreviewOpen}
                onClose={() => setSchedulePreviewOpen(false)}
                previewData={schedulePreviewData}
                // selectedSessionName={selectedSession?.label || ""}

                // onContinue={(payload) => {
                //     setSchedulePreviewOpen(false);
                //     setPendingCalculativePayload(payload); // final payload
                //     setOtpModalOpen(true); // then open confirm modal
                // }}
                isSubmittingCalc={isSubmittingCalc}

                // onContinue={(payload,) => {
                //     setSchedulePreviewOpen(false);
                //     setPendingCalculativePayload(payload);
                //     handleConfirmCalculative();
                // }}

                onContinue={async (payload) => {
                    // 🔥 Don't close modal here yet
                    setPendingCalculativePayload(payload);
                    await handleConfirmCalculative(payload); // waits for API
                    // ✅ after OTP comes, handleConfirmCalculative itself will open otp modal
                    setSchedulePreviewOpen(false); // close preview only after success
                }}
            />
            <OtpModal
                title="Confirmation!"
                heading="Please enter 6 digit OTP to confirm the fee schedule"
                isOpen={otpModalOpen}
                onConfirm={handleConfirmOtp}
                onCancel={handleCancelOtp}
                studentResponse={studentResponse}
                onResend={handlesResendOtpToAssignedPerson}
                reverifyDiscountOtp={helpdeskperson}
                skipSelectOnResend={true}
            />

            {noticeData.course_mode ? (<FeeNoticeCourseWise
                isOpen={showPrintNoticeModal}
                // students={pendingCalculativePayload}
                noticeData={{
                    ...noticeData,
                    pendingPayload: pendingCalculativePayload,
                }}

                course={selectedCourse}
                onClose={() => {
                    setShowPrintNoticeModal(false);
                    navigate(-1);
                }}

            />) : (<FeeNoticeStudentWise
                isOpen={showPrintNoticeModal}
                // students={pendingCalculativePayload}
                noticeData={{
                    ...noticeData,
                    pendingPayload: pendingCalculativePayload,
                }}

                course={selectedCourse}
                onClose={() => {
                    setShowPrintNoticeModal(false);
                    navigate(-1);
                }}

            />)}





            <WaitFeeApprovalsModal isOpen={showWaittingModal}
                // feePlanId={specializationSubmitResponse?.unique_id}
                onClose={() => {
                    setShowWaitingModal(false)
                    setShowConfirmModal(true)

                    // navigate(-1)
                }} />
        </>
    );
};
